import { Type } from 'class-transformer';
import { TaskEntity } from '@core/entities';

export class GroupTasksList {
  @Type(() => TaskEntity)
  groupTask: TaskEntity[];
}
